import { ActionTypes } from '../constants/constants'
import AppDispatcher from '../dispatcher/appDispatcher'
import { Contract, FuturesDatum, FuturesTile } from '../types'
import Store from './store'

var _tilesGroups: Record<string, string> = {}
var _tiles: Record<string, FuturesTile> = {}
var _tileOrder: string[] = []
class TilesStore extends Store {
  getTiles() {
    return _tiles
  }

  getTilesList() {
    return Object.keys(_tiles)
      .map(function (key) {
        return _tiles[key]
      })
      .sort((a, b) => _tileOrder.indexOf(a.ticker) - _tileOrder.indexOf(b.ticker))
  }

  getTile(ticker: string) {
    return _tiles[ticker]
  }

  getTilesGroup(ticker: string) {
    return _tilesGroups[ticker]
  }

  getTilesInGroup(group: string) {
    var g = group.toUpperCase()
    return this.getTilesList().filter((tile) => _tilesGroups[tile.ticker] === g)
  }
}
var tilesStore = new TilesStore()
tilesStore.setMaxListeners(50)

// @ts-ignore
tilesStore.dispatchToken = AppDispatcher.register(function (payload) {
  var action = payload.action

  // eslint-disable-next-line default-case
  switch (action.type) {
    case ActionTypes.INIT:
      var groups = action.rows
      groups.forEach((group: FuturesDatum) => {
        group.contracts.forEach((contract: Contract) => {
          _tiles[contract.ticker] = contract
          _tilesGroups[contract.ticker] = group.ticker
          _tileOrder.push(contract.ticker)
        })
      })
      tilesStore.emitChange()
      break

    case ActionTypes.INIT_TILES:
      _tiles = action.tiles
      tilesStore.emitChange()
      break

    case ActionTypes.UPDATE_DATA:
      var tiles = action.tiles
      _tiles = tiles
      tilesStore.emitChange()
      break
  }
})

export default tilesStore
